import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useReducer,
} from 'react';
import { Text } from 'grommet';
import {
  onFetchRepos,
  onFetchReposFailure,
  onFetchReposSuccess,
} from '../actions/Home';
import homeReducer, { IState } from '../reducers/Home';
import { fetchRepositoriesWithContributors } from '../services/github';
import { ContributorsColumn, RepositoryColumn } from '../utils/homeTable';

interface IContextProps {
  state: IState;
  fetchMore: () => void;
  dispatch: ({ type }: { type: string }) => void;
}
export const HomeContext = createContext({} as IContextProps);

/** Initial State */
const initialState = {
  repos: [],
  dataTable: {
    columns: [
      {
        property: 'name',
        header: <Text>Repository</Text>,
        primary: true,
        render: RepositoryColumn,
      },
      {
        property: 'contributors',
        header: 'Contributors',
        render: ContributorsColumn,
      },
    ],
    data: [],
  },
  page: 1,
  loading: false,
};

function HomeProvider(props: any) {
  const [state, dispatch] = useReducer(homeReducer, initialState);

  const fetchMore = async () => {
    try {
      dispatch(onFetchRepos());
      const repos = await fetchRepositoriesWithContributors(state.page);
      dispatch(onFetchReposSuccess(repos));
    } catch (error) {
      dispatch(onFetchReposFailure());
      console.error(error);
    }
  };

  const value = { state, fetchMore, dispatch };

  const initialLoad = useCallback(async () => {
    try {
      dispatch(onFetchRepos());
      const repos = await fetchRepositoriesWithContributors();
      dispatch(onFetchReposSuccess(repos));
    } catch (error) {
      dispatch(onFetchReposFailure());
      alert('An unexpected error ocurred, try again. API Rate Limit Exceeded?');
      console.error(error);
    }
  }, []);

  useEffect(() => {
    initialLoad();
  }, [initialLoad]);

  return <HomeContext.Provider value={value} {...props} />;
}

function useHomeContext() {
  return useContext(HomeContext);
}

export { HomeProvider, useHomeContext };
